import { Injectable, ErrorHandler } from '@angular/core';
import { SweetAlertService } from './sweetalert.service';
import { Helpers } from '../helpers';
import { ApiError } from '../models/api-error';
import { HttpErrorResponse } from '@angular/common/http';
import { LoadingService } from './loading.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(private alertService: SweetAlertService, private loading: LoadingService) { }

    handleError(error: any): void {
        this.loading.hide();
        const date = new Date().toISOString();
        if (!error.message || error.message == '') {
            error.message = 'An error occured!';
        }
        if (error instanceof ApiError) {
            this.alertService.error(error.message);
            console.error(date, 'Api error', error.message);
        } else if (error instanceof HttpErrorResponse) {
            this.showDefaultErrorAlert();
            console.error(
                date,
                'HTTP error',
                error.message,
                'Status code:',
                (<HttpErrorResponse>error).status
            );
        } else if (error instanceof TypeError) {
            this.showDefaultErrorAlert();
            console.error(date, 'Type error', error.message);
        } else if (error instanceof Error) {
            if (error['showMessage']) this.alertService.error(error.message);
            else this.showDefaultErrorAlert();
            console.error(date, 'General error', error.message);
        } else {
            this.showDefaultErrorAlert();
            console.error(
                date,
                'Nobody threw an Error but something happened!',
                error
            );
        }
    }

    showDefaultErrorAlert() {
        this.alertService.error('An error occured!');
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/_services/error-handler.service.ts